import styled, { css } from "styled-components";

import { SelectionBoxSize, SelectionBoxStyleProps } from "../types";
import {
    VOTEBOX_BORDER_WIDTH,
    VOTEBOX_BOX_BORDER_COLOR,
    VOTEBOX_DISABLED_BORDER_COLOR,
    VOTEBOX_SELECTED_BOX_BACKGROUND_COLOR,
    VOTEBOX_WHITE,
} from "../voteboxTokens";

const BOX_SIZES: Record<SelectionBoxSize, string> = {
    large: "22px",
    medium: "18px",
    small: "16px",
};
// Candidates have no color of their own: their box is a bit larger, as in the mockup.
const CANDIDATE_LARGE_BOX_SIZE = "24px";
const BOX_RADII: Record<SelectionBoxSize, string> = {
    large: "8px",
    medium: "6px",
    small: "5px",
};

function getBoxSize({ $color, $size }: SelectionBoxStyleProps) {
    if ("large" === $size && !$color) {
        return CANDIDATE_LARGE_BOX_SIZE;
    }

    return BOX_SIZES[$size];
}

function getEmptyBoxBorderColor({
    $color,
    $isDisabled,
}: SelectionBoxStyleProps) {
    if ($isDisabled) {
        return VOTEBOX_DISABLED_BORDER_COLOR;
    }

    // A deliberation option draws its box in its text color: on hover, when the option
    // fills with its color and its text turns white, the box stays visible.
    if ($color) {
        return "currentColor";
    }

    return VOTEBOX_BOX_BORDER_COLOR;
}

function getBoxColors(props: SelectionBoxStyleProps) {
    if (props.$isActive && props.$color) {
        return css`
            background: ${VOTEBOX_WHITE};
            border: 0;
        `;
    }

    if (props.$isActive) {
        return css`
            background: ${VOTEBOX_SELECTED_BOX_BACKGROUND_COLOR};
            border: ${VOTEBOX_BORDER_WIDTH} solid ${VOTEBOX_WHITE};
        `;
    }

    return css`
        background: transparent;
        border: ${VOTEBOX_BORDER_WIDTH} solid ${getEmptyBoxBorderColor(props)};
    `;
}

export const Box = styled.span<SelectionBoxStyleProps>`
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: ${(props) => getBoxSize(props)};
    height: ${(props) => getBoxSize(props)};
    border-radius: ${(props) => BOX_RADII[props.$size]};
    ${(props) => getBoxColors(props)}
`;
